export const KAPHY_BASE_URL = "https://kaphy-insurance-api-24bfecb5d4bb.herokuapp.com";
